module.exports = __webpack_public_path__ + "18efb8bf63308fc43b72231049b657b5.woff";